import { BaseSelectProps, FormControl, FormLabel, InputLabel, InputLabelProps, Select } from '@mui/material';
import React, { ReactElement } from 'react';
import { MoFieldErrorText } from '../MoFieldErrorText';

export interface MoSelectProps extends BaseSelectProps {
  name: string;
  label: string;
  helperText?: string | ReactElement;
  floatingLabel?: boolean;
  InputLabelProps?: Partial<InputLabelProps>;
}

export function MoSelect({
  name,
  label,
  fullWidth = true,
  floatingLabel = true,
  error,
  helperText,
  InputLabelProps: inputLabelProps,
  ...props
}: MoSelectProps): ReactElement {
  return (
    <FormControl fullWidth={fullWidth}>
      {floatingLabel ? (
        <InputLabel id={`${name}-label`} error={error} {...inputLabelProps}>
          {label}
        </InputLabel>
      ) : (
        <FormLabel id={`${name}-label`} htmlFor={name} error={error}>
          {label}
        </FormLabel>
      )}
      <Select
        labelId={`${name}-label`}
        id={name}
        label={floatingLabel ? label : undefined}
        fullWidth={fullWidth}
        error={error}
        notched={inputLabelProps?.shrink || undefined}
        {...props}
      />
      {error && helperText && <MoFieldErrorText>{helperText}</MoFieldErrorText>}
    </FormControl>
  );
}
